import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-v',
  templateUrl: './step-section-v.component.html',
})
export class StepSectionVComponent {
  constructor(public mdcService: MdcService) { }
}
